/* template */
<template><div class="search-container"><es-icon color="#000000" name="search" size="20" class="search-icon"/><mpx-input type="text" :value="(keywords)" :placeholder="(placeholder)" @input="search" class="search"/><mpx-view @tap="clear" v-show="(keywords)" class="clear"><mpx-image src="https://dpubstatic.udache.com/static/dpubimg/oXTzcUM0JPGZ6UAQybX26.png" class="clear-icon"/></mpx-view></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m7266d794"}'>
  .search-container
    display flex
    padding 0 16px
    align-items center
    height 45px
    background #ffffff
    position relative
    z-index 99
  .search-icon
    position absolute
    left 31px
  .search
    padding-left 41px
    flex 1
    height 44px
    font-size 14px
    background #F6F7F8
    border-radius 8px
    box-sizing: border-box;
    &:focus
      outline none
  .clear
    position absolute
    right 16px
    z-index 100
    margin 12px
    display flex
    align-items center
    top 0
  .clear-icon
    width 20px
    height 20px
  input::-webkit-input-placeholder
    color #666666
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m7266d794"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./search-input.mpx.js?isComponent&outputPath=components%2Fsearch-input7266d794%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./search-input.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fsearch-input7266d794%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m7266d794"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/search-input7266d794/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'mpx-input':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-input.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
